import React, { useState, useRef, useEffect } from 'react';
import { Box, Grid2, Typography, useMediaQuery } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import Category from '@mui/icons-material/Category';

import { INDUSTRY_ICONS } from './utils'; // your map
// import CloseIcon from '@mui/icons-material/Close';
// import { Doughnut } from 'react-chartjs-2';
// import Image from 'next/image';
import {
  FormPublicDesignFragment,
  FormPublicPageFragment,
} from '@/graphql/fragment/form.public.fragment';
import { SubmissionPublicFieldFragment } from '@/graphql/fragment/submission.public.fragment';
import {
  getFieldValue,
  getGeoData,
  getIndustryIcon,
  getIndustryNameFromId,
  getRevenueAtRisk,
  getRevenueRange,
} from './utils';
import orb from './assets/crop-blurred-circle-4146-2113px.png';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { industrySnippets } from './utils';
import { IndustryCard } from './industryCard';

// Chart.js registration
//import { Chart, ArcElement, Tooltip as ChartTooltip, Legend } from 'chart.js';
// import { BarChart } from './barChart';
// import { PieChart } from './pieChart';
// import { StackedHorizontalBarChart } from './stackedHorizontalBarChart';
//Chart.register(ArcElement, ChartTooltip, Legend);

const barchartData1: any = {
  labels: ['<50M', '<100M', '<250M', '<500M', '<750M', '<1B', '<1B+'],
  datasets: [
    {
      label: 'My First Dataset',
      data: [37, 18, 15, 11, 11, 3, 4],
      backgroundColor: [
        '#67BBD0',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
      ],
      borderColor: [
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
      ],
      borderWidth: 1,
    },
  ],
};

const barchartData2: any = {
  labels: ['Poor', 'Fair', 'Good', 'Excellent', "Don't know"],
  datasets: [
    {
      label: 'My First Dataset',
      data: [10, 9, 51, 40, 10],
      backgroundColor: [
        '#67BBD0',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
      ],
      borderColor: [
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
      ],
      borderWidth: 1,
    },
  ],
};

const barchartData3: any = {
  labels: ['None', 'Limited', 'Moderate', 'Fundamental'],
  datasets: [
    {
      label: 'My First Dataset',
      data: [10, 9, 51, 40],
      backgroundColor: [
        '#67BBD0',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
        'rgba(201, 203, 207, 0.2)',
      ],
      borderColor: [
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
        'rgb(201, 203, 207)',
      ],
      borderWidth: 1,
    },
  ],
};

interface Props {
  page: FormPublicPageFragment;
  design: FormPublicDesignFragment;
  answers: SubmissionPublicFieldFragment[];
}

export const GEOEndPage: React.FC<Props> = ({ page, design, answers }) => {
  const revenue = getRevenueRange(String(getFieldValue('NjGXmV', answers)));
  console.log('Revenue: ', revenue);
  const impactedRevenueLow = Array.isArray(revenue)
    ? getGeoData(answers, Number(revenue[0]))
    : getGeoData(answers, Number(revenue));
  const impactedRevenueHigh = Array.isArray(revenue)
    ? getGeoData(answers, Number(revenue[1]))
    : getGeoData(answers, Number(revenue));
  const revenueAtRiskLow = getRevenueAtRisk(impactedRevenueLow);
  const revenueAtRiskHigh = getRevenueAtRisk(impactedRevenueHigh);
  const industryString = getFieldValue('wVJ4O7', answers);

  type Props = { industryId: string } & SvgIconProps;

  function IndustryIcon({ industryId, ...props }: Props) {
    const Icon: SvgIconComponent =
      INDUSTRY_ICONS[industryId.trim()] ?? Category;
    return (
      <Icon
        sx={{
          fontSize: 44, // bigger (px)
          color: 'text.primary', // darker (theme-aware)
        }}
      />
    );
  }

  console.log(
    'revenueAtRiskLow: ',
    revenueAtRiskLow,
    'revenueAtRiskHigh: ',
    revenueAtRiskHigh
  );

  if (!page.show) return null;

  return (
    <>
      <Grid2
        container
        sx={{
          marginTop: '113px',
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          alignItems: 'center',
          minHeight: 'calc(100vh - 113px)',
          overflowY: 'auto',
          overflowX: 'hidden',
          backgroundImage: `url(${orb})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'bottom right',
          backgroundSize: '800px 404px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'start',
            width: '100%',
            flexDirection: 'column',
          }}
        >
          <Typography
            sx={{
              typography: { xs: 'h5', sm: 'h4' },
              paddingTop: { xs: '10px', sm: 0 },
            }}
            style={{
              color: design.colors.question,
              fontWeight: 700,
            }}
          >
            Your AI-Search Revenue Report
          </Typography>
          <Typography
            sx={{ typography: { xs: 'h4', sm: 'h3' } }}
            style={{
              color: design.colors.question,
              fontWeight: 800,
            }}
          >
            Revenue At Risk: $
            {revenueAtRiskLow
              ? Math.round(revenueAtRiskLow).toLocaleString()
              : 0}
            {revenueAtRiskLow !== revenueAtRiskHigh && (
              <React.Fragment>
                {' - '}$
                {revenueAtRiskHigh
                  ? Math.round(revenueAtRiskHigh).toLocaleString()
                  : 0}
              </React.Fragment>
            )}
          </Typography>
          <Typography
            sx={{
              fontSize: '16px',
              marginTop: '10px',
            }}
            style={{
              color: design.colors.question,
              fontWeight: 700,
              //letterSpacing: '4.56px',
            }}
          >
            Revenue at Risk is the annual revenue your company could potentially
            forfeit if you fail to improve your GEO strategy.
          </Typography>
          <Typography
            sx={{
              fontSize: '28px',
              textTransform: 'capitalize',
              marginTop: '25px',
            }}
            style={{
              color: design.colors.question,
              fontWeight: 700,
              //letterSpacing: '4.56px',
            }}
          >
            Industry Insights
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
            }}
          >
            <IndustryIcon industryId={industryString as string} />
            <Typography
              sx={{
                // typography: { xs: 'h5', sm: 'h3' },
                paddingTop: { xs: '10px', sm: 0 },
                fontSize: '22px',
                textTransform: 'capitalize',
              }}
              style={{
                color: design.colors.question,
                fontWeight: 700,
                //letterSpacing: '4.56px',
              }}
            >
              {getIndustryNameFromId(industryString as string)}{' '}
            </Typography>
          </Box>
          <div className='geo-impact-carousel-wrapper'>
            <Carousel
              additionalTransfrom={0}
              arrows
              autoPlaySpeed={3000}
              centerMode={false}
              className=''
              containerClass='container-with-dots'
              dotListClass=''
              draggable
              focusOnSelect={false}
              infinite
              itemClass=''
              keyBoardControl
              minimumTouchDrag={80}
              pauseOnHover
              renderArrowsWhenDisabled={false}
              renderButtonGroupOutside={false}
              renderDotsOutside={false}
              responsive={{
                desktop: {
                  breakpoint: {
                    max: 3000,
                    min: 1024,
                  },
                  items: 3,
                  //partialVisibilityGutter: 40,
                },
                mobile: {
                  breakpoint: {
                    max: 464,
                    min: 0,
                  },
                  items: 3,
                  //partialVisibilityGutter: 30,
                },
                tablet: {
                  breakpoint: {
                    max: 1024,
                    min: 464,
                  },
                  items: 3,
                  //partialVisibilityGutter: 30,
                },
              }}
              rewind={false}
              rewindWithAnimation={false}
              rtl={false}
              shouldResetAutoplay
              showDots
              sliderClass=''
              slidesToSlide={1}
              swipeable
            >
              {industrySnippets[
                industryString as keyof typeof industrySnippets
              ]?.map((snippet, index) => (
                <IndustryCard key={index} text={snippet} />
              ))}
            </Carousel>
          </div>
        </Box>
      </Grid2>
    </>
  );
};
